import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-newhomeowners',
  templateUrl: './newhomeowners.component.html',
  styleUrls: ['./newhomeowners.component.scss']
})
export class NewhomeownersComponent implements OnInit {

  id: number;
  toggle: boolean;
  constructor(private actRoute: ActivatedRoute, private router: Router) {
    this.id = this.actRoute.snapshot.params.id;
    this.router.events.subscribe(event => {
      if(event instanceof NavigationEnd){
        console.log(event.url)
        if(event.url == '/real-estate-toolkit/new-homeowners')
          this.toggle = true;
       }
    }
 )
  }
  ngAfterViewInit() {

  }

  ngOnInit() {
  }

}
